function setArrowOffset(carouselTrack) {
    var trackHeight = carouselTrack.offsetHeight;
    var carousel = carouselTrack.closest('.images-carousel');
    var arrowsNav = carousel.querySelector('.arrows');
    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    var arrowHeight = prevArrow.offsetHeight;
    var offset = (trackHeight / 2) - (arrowHeight / 2);

    prevArrow.style.top = offset + 'px';
    nextArrow.style.top = offset + 'px';
}

function getFlexGap(element) {
    const styles = window.getComputedStyle(element);
    var gap = 0;

    if (styles) {
        var rawGap = styles.columnGap || styles.gap;
        if (rawGap === 'normal') {
            gap = 0;
        } else {
            gap = parseFloat(rawGap);
        }
    }
    
    return parseFloat(gap);
}

function enableTransformDrag(element, arrowsNav, carousel) {
    // var isInitialLoad = true;
    // var hasFilledClones = false;

    var items = Array.from(element.children);
    var activeIndex = 0;

    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var isAnimating = false;
    var isDragging = false;
    var isAutoPlay = element.dataset.autoplay === '1' ? true : false;
    var speed = element.dataset.speed ? element.dataset.speed : 5;

    var autoPlayIntervalId = null;
    var startX = 0;
    var startY = 0;

    var currentTranslate = 0;
    var lastTranslate = 0;
    var shiftDirection = null;

    // var itemWidth = 0;
    // var itemGap = 0;
    var gap = getFlexGap(element);
    var dragThreshold = 5;

    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    function initNextShift(callback) {
        var firstItem = element.children[0];
        var gap = getFlexGap(element);
        var shiftWidth = firstItem.offsetWidth + gap;
    
        element.appendChild(firstItem);

        currentTranslate += shiftWidth;
        element.style.transition = 'none';
        element.style.transform = 'translateX(' + currentTranslate + 'px)';
        void element.offsetWidth;

        items = Array.from(element.children);
        activeIndex--

        if (typeof callback === 'function') {
            callback();
        }
    }

    function initPrevShift() {
        var lastItem = element.children[element.children.length - 1];
        var gap = getFlexGap(element);
        var shiftWidth = lastItem.offsetWidth + gap;
    
        element.insertBefore(lastItem, element.children[0]);

        currentTranslate -= shiftWidth;
        element.style.transition = 'none';
        element.style.transform = 'translateX(' + currentTranslate + 'px)';
        void element.offsetWidth;

        items = Array.from(element.children);
        var maxIndex = items.length - 2;
        activeIndex = Math.min(activeIndex + 1, maxIndex);
    }

    function handlePrevArrowClick() {
        if (isAnimating) return;
        isAnimating = true;
        stopAutoPlay();
        
        activeIndex--
        shiftDirection = 'prev';
        centerActiveItem(activeIndex);
    }

    function handleNextArrowClick() {
        if (isAnimating) return;
        isAnimating = true;
        stopAutoPlay();

        initNextShift(function () {
            activeIndex++;
            centerActiveItem(activeIndex);
        });
    }

    function getTotalItemWidth(items, gap) {
        var total = 0;
        items.forEach(function (item, i) {
            total += item.offsetWidth;
            if (i > 0) total += gap;
        });
        return total;
    }

    function duplicateToFill() {
        var originalItems = Array.from(items);
        var totalItemsWidth = getTotalItemWidth(items, gap);
        var minFillWidth = totalItemsWidth + getTotalItemWidth([items[0]], gap);

        if (originalItems.length == 1) {
            minFillWidth = element.offsetWidth * 3;
        }
        
        var clones = [];
        
        while (totalItemsWidth < minFillWidth) {

            originalItems.forEach(function (item) {
                var clone = item.cloneNode(true);
                clone.classList.add('dynamic-clone');
                clone.setAttribute('data-id', item.getAttribute('data-id'));
                element.appendChild(clone);
                clones.push(clone);
                totalItemsWidth += item.offsetWidth + gap;
                // totalItemsWidth += getTotalItemWidth([item], gap);
            });

        }
    
        items = Array.from(element.children);

        var firstItemId = originalItems[0].getAttribute('data-id');
        var firstItemClones = items.filter(function(el) {
            return el.getAttribute('data-id') === firstItemId;
        });

        if (firstItemClones.length > 1) {
            var secondFirstClone = firstItemClones[1];
            if (originalItems.length == 1) {
                secondFirstClone = firstItemClones[2];
            }
            
            activeIndex = items.indexOf(secondFirstClone);
        }
        
        centerActiveItem(activeIndex, true);
    }

    function transformImageCarouselPrevNextImg(items, index) {
        items.forEach(function(item) {
            var itemImg = item.querySelector('.images-carousel-image');
            if (itemImg) {
                itemImg.style.transformOrigin = 'center center';
            }
        });

        var prevItem = items[index - 1];
        var nextItem = items[index + 1];

        if (prevItem) {
            var prevImg = prevItem.querySelector('.images-carousel-image');
        }
        
        if (nextItem) {
            var nextImg = nextItem.querySelector('.images-carousel-image');
        }

        if (prevImg) {
            prevImg.style.transformOrigin = 'right center';
        }
          
        if (nextImg) {
            nextImg.style.transformOrigin = 'left center';
        }
    }

    function centerActiveItem(index, initialLoad) {
        if (!initialLoad) {
            initialLoad = false;
        }
        var containerWidth = element.parentElement.offsetWidth;
        var activeItem = items[index];
        var itemWidth = activeItem.offsetWidth;
        var itemLeft = activeItem.offsetLeft;

        var offset = itemLeft - (containerWidth / 2 - itemWidth / 2);
        if (element.getAttribute('data-align') === "left") {
            offset = itemLeft;
        }

        currentTranslate = -offset;

        element.style.transition = initialLoad ? "" : "transform 0.6s ease-in-out";
        element.style.transform = 'translateX(' + currentTranslate + 'px)';

        setActiveClass(activeItem);

        var hasImagesCarousel = element.closest('.block');
        if (hasImagesCarousel && hasImagesCarousel.classList.contains('images-block')) {

            transformImageCarouselPrevNextImg(items, index);
            setActiveItemInfo(activeItem);
        }
    }

    function getClientX(e) {
        if (e.touches && e.touches.length > 0) {
            return e.touches[0].clientX;
        } else if (e.changedTouches && e.changedTouches.length > 0) {
            return e.changedTouches[0].clientX;
        } else {
            return e.clientX;
        }
    }

    function handleSnapToItem(e) {
        var dx = getClientX(e) - startX;
        var threshold = 5;
        
        if (Math.abs(dx) > threshold) {
            isAnimating = true;
    
            if (dx < 0) {
                activeIndex++;
                shiftDirection = null;
                initNextShift(function() {
                    centerActiveItem(activeIndex);
                });
            } else {
                activeIndex--;
                shiftDirection = 'prev';
            }

            centerActiveItem(activeIndex);
    
        }
    }

    function setActiveClass(item) {
        Array.from(items).forEach(function(item) {
            item.classList.remove('active');
        });
        item.classList.add('active');
    }

    function setActiveItemInfo(activeItem) {
        var carousel = activeItem.closest('.images-carousel');
        var info = carousel.querySelector('.images-carousel-item-info');
        info.classList.remove('active');

        var title = activeItem.getAttribute("data-title") || "";
        var description = activeItem.getAttribute("data-description") || "";
        
        var titleEl = carousel.querySelector('.carousel-title');
        var descEl = carousel.querySelector('.carousel-description');

        if (titleEl) titleEl.textContent = title;
        if (descEl) descEl.textContent = description;
        if (title || description) info.classList.add('active');

    }

    function handleBrowserResize() {
        // var firstItem = element.children[0];
        // if (firstItem) {
        //     itemWidth = parseFloat(firstItem.getBoundingClientRect().width.toFixed(2));
        //     itemGap = getFlexGap(element);
        // }

        // step = itemWidth + itemGap;
        // offsetMultiplier = window.innerWidth < 768 ? 0.65 : 0;
        // initialOffset = -(step * offsetMultiplier) + (itemGap / 2);

        // var activeItem = element.querySelector('.active');
        // if (activeItem) {
        //     var index = Array.from(element.children).indexOf(activeItem) - 1;
        //     currentTranslate = initialOffset - (index * step);
        //     lastTranslate = currentTranslate;
        
        //     element.style.transition = "none";
        //     element.style.transform = "translateX(" + currentTranslate + "px)";
        // }

        // setActiveClassForSecondFromSnap(element, currentTranslate);
        centerActiveItem(activeIndex);
        setArrowOffset(element);
    }

    function handleItemClick(e) {

        stopAutoPlay();
        isDragging = false;
        hasMoved = false;
        
        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;
        
        if(!linkElm) return;

        var target = linkElm.getAttribute('target');
        var url = linkElm.hasAttribute('href') ? linkElm.getAttribute('href') : '';
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (video || modal) {
            return linkElm.click();
        }

        if (url) {
            e.stopPropagation();

            if(url.includes('mailto:')) {
                return window.location.href = url;
            }

            var a = document.createElement('a');
            a.href = url;
            a.target = target || '_self';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            a.remove();
        }
    }

    function getCurrentActiveItem() {
        var activeItem = element.querySelector('.images-carousel-item.active');
        return activeItem;
    }

    function onPointerDown(e) {
        if (isAnimating) return;

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        startX = e.clientX;
        startY = e.clientY;

        element.style.transition = "";
        element.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
        if (!isDragging || e.pointerType === 'mouse' && e.buttons !== 1) return;
        
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        if (!hasMoved && Math.abs(dy) > Math.abs(dx)) {
            isDragging = false;
            element.releasePointerCapture(e.pointerId);
            return;
        }

        if (!hasMoved && Math.abs(dx) > dragThreshold) {
            hasMoved = true;
            element.classList.add('dragging');

            shiftDirection = dx < 0 ? 'next' : 'prev';
        }
    
        if (!hasMoved) return;

        e.preventDefault();

        lastTranslate = currentTranslate + dx;

        // var maxTranslate = -(element.scrollWidth - element.offsetWidth);
        // var maxOverflow = itemWidth + itemGap;
        
        // lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
        element.style.transform = "translateX(" + lastTranslate + "px)";
    }

    function onPointerUp(e) {

        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }

        currentTranslate = lastTranslate;
        
        handleSnapToItem(e);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function onTouchStart(e) {
        if (isAnimating) return;

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;

        element.style.transition = "";
    }
      
    function onTouchMove(e) {
        if (!isDragging) return;
    
        var touch = e.touches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
    
        if (!hasMoved) {
            if (Math.abs(dy) > Math.abs(dx)) {
                isDragging = false;
                return;
            }
            if (Math.abs(dx) > dragThreshold) {
                hasMoved = true;
            }
        }
    
        if (hasMoved) {
            e.preventDefault();

            shiftDirection = dx < 0 ? 'next' : 'prev';

            lastTranslate = currentTranslate + dx;
    
            // var maxTranslate = -(element.scrollWidth - element.offsetWidth);
            // var maxOverflow = itemWidth + itemGap;
            
            // lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
            element.style.transform = "translateX(" + lastTranslate + "px)";
        }
    }
      
    function onTouchEnd(e) {
        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }

        currentTranslate = lastTranslate;
        
        handleSnapToItem(e);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function autoPlay() {
        if (!isAutoPlay) return;
    
        autoPlayIntervalId = setInterval(function () {
            if (!isDragging && !isAnimating) {
                initNextShift(function () {
                    activeIndex++;
                    centerActiveItem(activeIndex);
                });
            }
        }, (speed * 1000));
    }

    function stopAutoPlay() {
        if (autoPlayIntervalId) {
            clearInterval(autoPlayIntervalId);
            autoPlayIntervalId = null;
            isAutoPlay = false;
        }
    }

    function imageClick(e) {
        e.preventDefault();

        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;

        if (!linkElm) return;

        var url = linkElm.getAttribute('href');
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (!url && !video && !modal) {
            e.stopPropagation();
        }
    }

    function handleSlideTransition(e) {
        if (e.propertyName !== 'transform') return;
    
        if (shiftDirection === 'next') {
            // activeIndex--
            initNextShift();
        } else if (shiftDirection === 'prev') {
            // activeIndex++
            initPrevShift();
        }
        
        shiftDirection = null;
        isAnimating = false;
    }

    // function observeCarouselHeight() {
    
    //     if (!carousel) {
    //         console.warn('Carousel not found');
    //         return;
    //     }
    
    //     const observer = new ResizeObserver(entries => {
    //         for (const entry of entries) {
    //             const height = parseFloat(entry.contentRect.height);
    //             console.log('Observed carousel height change:', height);
    //             window.parent.postMessage({ type: 'setIframeHeight', height }, '*');
    //         }
    //     });
    
    //     observer.observe(carousel);
    // }

    function checkForCPanel() {
        try {
            const parentBody = window.parent.document.body;
    
            if (
                parentBody.id === 'cpApp' ||
                parentBody.classList.contains('cp-app')
            ) {
                setTimeout( function() {
                    handleBrowserResize();
                }, 50);
                // observeCarouselHeight();
            }
        } catch (e) {
            console.warn('Could not access parent body:', e);
        }
    }

    prevArrow.addEventListener('click', handlePrevArrowClick);
    nextArrow.addEventListener('click', handleNextArrowClick);
    element.addEventListener('click', function(e) {imageClick(e)});

    if (!isTouchDevice) {
        element.addEventListener('pointerdown', function(e) { onPointerDown(e) }, { passive: true });
        element.addEventListener('pointermove', function(e) { onPointerMove(e) }, { passive: false });
        element.addEventListener('pointerup', function(e) { onPointerUp(e) });
    } else {
        element.addEventListener('touchstart', function(e) { onTouchStart(e) }, { passive: true });
        element.addEventListener('touchmove', function(e) { onTouchMove(e) }, { passive: false });
        element.addEventListener('touchend', function(e) { onTouchEnd(e) });
    }

    element.addEventListener('transitionend', function (e) { handleSlideTransition(e) });
    element.addEventListener('webkitTransitionEnd', function (e) { handleSlideTransition(e) });
    window.addEventListener('resize', handleBrowserResize);

    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
            setTimeout( function() {
                handleBrowserResize();
            }, 50);
        }
    });

    duplicateToFill();
    autoPlay();
    checkForCPanel();
    
}
 
var init = function () {
    
    var carousels = document.querySelectorAll('.images-carousel');

    carousels.forEach(function(carousel) {

        var track = carousel.querySelector('.images-carousel-track');
        var arrows = carousel.querySelector('.arrows');

        if (track && arrows) {
            setArrowOffset(track);
            enableTransformDrag(track, arrows, carousel);
        }

    });

};

module.exports = {
  init: init
};